import * as postsApi from '../api/posts'

import {
  RECEIVE_POSTS_ERROR,
  RECEIVE_POSTS_SUCCESS,
  REQUEST_POSTS,
} from '../action_constants'

function requestPosts() {
  return {
    type: REQUEST_POSTS,
  }
}

function receivePosts({ items }) {
  return {
    type: RECEIVE_POSTS_SUCCESS,
    items,
  }
}

function receivePostsError({ error }) {
  return {
    type: RECEIVE_POSTS_ERROR,
    error,
  }
}

export function fetchAll() {
  return function(dispatch) {
    dispatch(requestPosts())
    return postsApi
      .fetchAll()
      .then(response => {
        dispatch(receivePosts({ items: response.data }))
      })
      .catch(e => {
        dispatch(receivePostsError({ error: e }))
      })
  }
}
